"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.redirectSiteSearch = exports.getBloomreachSearchResult = void 0;

require("core-js/modules/es6.regexp.split");

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _jsonp = _interopRequireDefault(require("jsonp"));

var _axios = require("axios");

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _helperUtils = require("./helperUtils");

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");

var _recentlyViewedProductsFunctions = require("./recently-viewed-products-functions");

(0, _uigCdnLibraries.polyfillFetch)(); //get current brand

var currentBrand = typeof window !== 'undefined' && window.brandName && window.brandName === 'TP' ? 'tinyprints' : 'shutterfly';

var callTracker = function callTracker(category, mobile, status, query) {
  if (typeof window === 'undefined') {
    return;
  } //URI for tracking, only on shutterfly domain (not on tp)


  var https = window.location.protocol;
  var base = window.location.host;

  if (currentBrand === 'shutterfly') {
    var reqURI = "searchlog?category=".concat(category, "&mobile=").concat(mobile, "&status=").concat(status, "&query=").concat(query);
    var fullUrl = "".concat(https, "//").concat(base, "/").concat(reqURI);
    (0, _axios.get)(fullUrl).catch(function (ex) {
      return false;
    });
  }
};

var getJsonpData = function getJsonpData(target) {
  var jsonpOpts = {
    timeout: 5000
  };
  return new _promise.default(function (resolve, reject) {
    (0, _jsonp.default)(target, jsonpOpts, function (err, message) {
      if (err) {
        return reject(err);
      } else {
        return resolve(message);
      }
    });
  });
}; //search url to use for BR


var searchUrl = (0, _helperUtils.getBloomreachUrlBasedOnBrand)(currentBrand, (0, _uigCurrentEnvironmentUtil.getCurrentEnv)());

var getBloomreachSearchResult = function getBloomreachSearchResult(query) {
  var url = typeof window !== 'undefined' ? window.location.href : '';
  var ref_url = typeof document !== 'undefined' ? document.referrer : '';

  if (ref_url) {
    ref_url = encodeURIComponent(ref_url);
  }

  if (url) {
    url = encodeURIComponent(url);
  }

  var brUid2 = (0, _recentlyViewedProductsFunctions.getCookieValue)('_br_uid_2');
  return fetch("".concat(searchUrl, "&q=").concat(query, "&_br_uid_2=").concat(brUid2, "&ref_url=").concat(ref_url, "&url=").concat(url)).then(function (result) {
    callTracker('terms', 'false', '200', query);
    return _promise.default.resolve(result.json());
  }).catch(function (ex) {
    callTracker('terms', 'false', '400', query);
    throw new Error(query);
  });
}; // redirect to sitesearch for given search terms


exports.getBloomreachSearchResult = getBloomreachSearchResult;

var redirectSiteSearch = function redirectSiteSearch(queryStr) {
  if (typeof window === 'undefined') {
    return '';
  }

  var searchStr = queryStr;
  var fmtSearchStr = searchStr.split(' ').join('+');
  var https = window.location.protocol;
  var base = window.location.host;
  var fullUrl;

  if (!!base && (base.indexOf('tinyprints') !== -1 || base.indexOf('tp') !== -1)) {
    fullUrl = "".concat(https, "//").concat(base, "/tp/sitesearch/").concat(fmtSearchStr);
  } else {
    fullUrl = "".concat(https, "//").concat(base, "/sitesearch/").concat(fmtSearchStr);
  }

  return fullUrl;
};

exports.redirectSiteSearch = redirectSiteSearch;